var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyinnerhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.58105 1.79194V6.54355C2.58105 6.75358 2.66449 6.95502 2.81301 7.10353C2.96152 7.25205 3.16296 7.33549 3.37299 7.33549H6.54073C6.75077 7.33549 6.9522 7.25205 7.10072 7.10353C7.24923 6.95502 7.33267 6.75358 7.33267 6.54355V3.07566C7.33266 2.97016 7.31156 2.86573 7.27063 2.76849C7.22969 2.67125 7.16974 2.58318 7.0943 2.50943L5.78166 1.2257C5.63371 1.08104 5.43502 1.00003 5.2281 1H3.37299C3.16296 1 2.96152 1.08344 2.81301 1.23195C2.66449 1.38047 2.58105 1.5819 2.58105 1.79194Z",
    stroke: "#1e88e5",
    strokeOpacity: 1,
    strokeWidth: 0.791936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.75161 7.33612V8.12805C5.75161 8.33809 5.66818 8.53952 5.51966 8.68803C5.37114 8.83655 5.16971 8.91999 4.95968 8.91999H1.79194C1.5819 8.91999 1.38047 8.83655 1.23195 8.68803C1.08344 8.53952 1 8.33809 1 8.12805V3.7724C1 3.56237 1.08344 3.36094 1.23195 3.21242C1.38047 3.0639 1.5819 2.98047 1.79194 2.98047H2.58387",
    stroke: "#1e88e5",
    strokeOpacity: 1,
    strokeWidth: 0.791936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyinnerhover);
export default __webpack_public_path__ + "static/media/copy inner hover.8ce061dddf2d11cd7e2e9314ddf36807.svg";
export { ForwardRef as ReactComponent };